export const HOST = process.env.HOST
export const HOST_URL = process.env.HOST_URL || "https://www.vnis.vn"

export const CONTENT_MANAGEMENT_PROVIDER = process.env.CONTENT_MANAGEMENT_PROVIDER
export const API_ENDPOINT_URL = `${CONTENT_MANAGEMENT_PROVIDER}/consumers/p/${HOST}`

export const COUNTRIES = require("./contries.json")

export const INITIAL_LOCALES = process.env.LOCALES?.split(",") || ["vi-VN", "en-US"]
export const INITIAL_LOCALE = process.env.DEFAULT_LOCALE || 'vi-VN'

export const API_SUBMIT_ENDPOINT_URL = process.env.API_SUBMIT_ENDPOINT_URL

export const MAILER_RECEIVER = process.env.MAILER_RECEIVER